export default __webpack_public_path__ + "c25f564ee538dea9f9381ba3733efa89.png";